"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isModalActive,
      width: 640,
      scroll: "keep"
    },
    on: {
      close: function close($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_c("form", {
    on: {
      submit: function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c("div", {
    staticClass: "modal-card"
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n          Justificar ausência\n        ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body",
    staticStyle: {
      "padding-bottom": "120px"
    }
  }, [_c("b-field", {
    attrs: {
      label: "Data da ausência"
    }
  }, [_c("b-datepicker", {
    attrs: {
      placeholder: "Selecione a data",
      "default-date": _vm.form.date,
      "max-date": new Date(),
      required: "",
      icon: "calendar-today"
    },
    model: {
      value: _vm.form.date,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "date", $$v);
      },
      expression: "form.date"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Título"
    }
  }, [_c("b-input", {
    attrs: {
      placeholder: "Ex.: Consulta médica, Viagem, etc.",
      required: ""
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Tipo de ausência"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione o tipo",
      expanded: "",
      required: ""
    },
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_c("option", {
    attrs: {
      value: "SICK_LEAVE"
    }
  }, [_vm._v("\n              Problemas de Saúde\n            ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "MEDICAL_CERTIFICATE"
    }
  }, [_vm._v("\n              Atestado Médico\n            ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "VACATION"
    }
  }, [_vm._v("\n              Férias\n            ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "OFF_DAY"
    }
  }, [_vm._v("\n              Folga\n            ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "AUTHORIZED"
    }
  }, [_vm._v("\n              Autorizado\n            ")]), _vm._v(" "), _c("option", {
    attrs: {
      value: "OTHER_REASONS"
    }
  }, [_vm._v("\n              Outro\n            ")])])], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Descrição"
    }
  }, [_c("b-input", {
    attrs: {
      type: "textarea",
      placeholder: "Descreva o motivo da ausência",
      rows: "4"
    },
    model: {
      value: _vm.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Horas compensadas"
    }
  }, [_c("b-timepicker", {
    attrs: {
      placeholder: "Total de horas compensadas",
      "hour-format": "24",
      "increment-minutes": 5,
      required: ""
    },
    model: {
      value: _vm.form.compensatedTime,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "compensatedTime", $$v);
      },
      expression: "form.compensatedTime"
    }
  })], 1)], 1), _vm._v(" "), _c("footer", {
    staticClass: "modal-card-foot"
  }, [_c("b-button", {
    staticClass: "btn",
    attrs: {
      type: "is-primary",
      "native-type": "submit"
    }
  }, [_vm._v("\n          Salvar\n        ")]), _vm._v(" "), _c("b-button", {
    on: {
      click: function click($event) {
        return _vm.$emit("onClose");
      }
    }
  }, [_vm._v("\n          Cancelar\n        ")])], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;